import SearchIcon from '@mui/icons-material/Search'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const FormInputBase = ({ children, label, disabled, onSubmit, inputBaseProps }) => {
  const {
    labelSuffix = '',
    labelColor,
    labelFontWeight,
    labelProps,
    labelSx = {},
    childrenSx = {},
    ...rootProps
  } = inputBaseProps || {}

  return (
    <Grid
      container
      alignItems="flex-start"
      spacing={2}
      {...rootProps}
      color={theme => theme.palette.secondary[80].main}
    >
      {label && (
        <Grid item>
          <Stack direction="row" alignItems="center" py={'8.5px'} {...labelProps}>
            <Typography
              fontWeight={labelFontWeight ?? 600}
              color={theme => labelColor ?? theme.palette.secondary[80].main}
              sx={labelSx}
            >
              {label}
            </Typography>

            {typeof labelSuffix === 'string' ? <Typography>{labelSuffix}</Typography> : labelSuffix}
          </Stack>
        </Grid>
      )}
      <Grid
        item
        sx={{
          // '& .MuiInputBase-root': { backgroundColor: '#FFF' },
          display: 'flex',
          ...childrenSx,
        }}
      >
        {children}
      </Grid>

      {onSubmit && (
        <Grid item>
          <IconButton disabled={disabled} onClick={onSubmit} sx={{ padding: 0 }}>
            <SearchIcon color="secondary_80" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  )
}

export default FormInputBase
